import React from 'react'
import $ from 'jquery'
import '../../utility/csrf'
import GlobalBanner from '../../components/globalBanner'
import LinnerDiv from '../../components/lineDiv'
import SubHeader from '../../components/subHeader'
import Note from '../../components/note'
import GuestPPLogIn from '../../components/guestPPLogIn'
import AmountWrapper from '../../components/amountWrapper'
import OrLine from '../../components/orLine'
import GuestForm from '../guest/guestForm'
import PayCreditOrDebit from '../../components/payCreditOrDebit'
import { i18n } from 'react-i18n'

import { handleLogIn, handleTokenReuse } from '../../utility/helper'

import templateData from '../../utility/getTemplateData'
import appStore from '../../stores/AppStore'
import AppDispatcher from '../../dispatcher/AppDispatcher'
import * as FPT from '../../utility/fpt'

export default React.createClass({

	mixins: [i18n('routes/guest')],

	getInitialState() {
		return {
			hasLogo: templateData.hasLogo,
			subHeaderLabel: templateData.donationName,
			orgName: templateData.charityName,
			donationId: templateData.donationId,
			guestRedirectUrl: templateData.guestRedirectUrl,
			showServiceErrors: false,
			errorMesages: []
		};
	},

	componentDidMount() {
		// Only adding page name, if "fptPageName=landing", in other cases track event will be triggered when template is loaded.
		if (templateData.fptPageName === 'landing') {
			FPT.trackPage('main:donate:wps:guest:guestform', 'main:donate:wps:guest:guestform:web::')
		}

		$('.spinneroverlay').hide();

		handleTokenReuse();

		let self = this

		// Handles serverside errors
		AppDispatcher.register(function(payload) {

			 if (payload.action && (payload.action.actionType === 'UPDATE_SERVER_ERRORS')) {

				let errorMesages = payload.action.item.serverErrors
				let showServiceErrors = errorMesages.length > 0

				self.setState({
					showServiceErrors: showServiceErrors,
					errorMesages: errorMesages
				});

				if (showServiceErrors) {
					setTimeout(() => {
						let errorEl = $('.service_error_holder:visible')
						$('html, body').animate({
							scrollTop: errorEl.offset() && errorEl.offset().top
						}, 1000);
					}, 200)
				}
			 }
		});
	},

	componentWillUnmount() {},

	getFPTDATA() {
		return {
			amount: appStore.getDonationAmount(),
			code: appStore.getDonationCode(),
			symbol: appStore.getDonationSymbol()
		}
	},

	handleLogIn(event) {
		event.preventDefault();
		if (appStore.getDonationAmount()) {
			FPT.trackLinkClickWithData('guestLogIn', this.getFPTDATA())
		}
		handleLogIn()
	},

	render() {
		let errorgeneric = this.i18n('error.generic')
		return (
			<div className="donate_wrapper">
				<div className="container">
					{this.state.showServiceErrors ?
						<div className="col-xs-12 col-sm-12 col-md-12 service_error_holder">
							{this.state.errorMesages.map(function(message) {
								return <div className="row" key={message.key}>
											<p className="col-xs-1 col-sm-1 col-md-1"><span className="icon icon-small icon-critical-small" aria-hidden="true"></span></p>
											<p className="col-xs-11 col-sm-11 col-md-11"style={{ paddingLeft: '5px', marginTop: '5px' }}>{message.value}</p>
								</div>;
							})}
						</div> : null}
					<GlobalBanner
						logourl={this.state.logourl}/>
					<SubHeader
						donationId={this.state.donationId}
						orgName={this.state.orgName}
						label={this.state.subHeaderLabel}/>
					<form id="guestForm" noValidate>
						<AmountWrapper />
						<p className="err_update_amount text-center">{errorgeneric}</p>
						<LinnerDiv />
						{templateData.charityNoteEnabled ? <Note /> : null}
						<GuestPPLogIn handleLogIn={this.handleLogIn}/>
						{
							/* <PPLogIn
								handleLogIn={this.handleLogIn}/>
							<OrLine /> */
						}
						<PayCreditOrDebit />
						<GuestForm />
					</form>
				</div>
			</div>
		)
	}
})



// WEBPACK FOOTER //
// ./pages/guest/guest.js